export const state = {
    // user_data: [
    //     { id: 1, name: "Jack", role: "Admin", email: "jack@email.com" },
    //     { id: 2, name: "Jill", role: "Team member", email: "jill@email.com" },
    // ],
    user_data: [],
    selected_user: null,
    // user_permissions: [
    //     {
    //         name: "Permission group 1",
    //         permissions: [
    //             { id: 1, name: "Permission 1", selected: true },
    //             { id: 2, name: "Permission 2", selected: false },
    //             { id: 3, name: "Permission 3", selected: false },
    //             { id: 8, name: "Permission 4", selected: true },
    //             { id: 9, name: "Permission 5", selected: true },
    //             { id: 10, name: "Permission 6", selected: false },
    //             { id: 11, name: "Permission 7", selected: true },
    //         ],
    //     },
    //     {
    //         name: "Permission group 2",
    //         permissions: [
    //             { id: 4, name: "Permission 1", selected: false },
    //             { id: 5, name: "Permission 2", selected: true },
    //             { id: 6, name: "Permission 3", selected: false },
    //         ],
    //     },
    // ],
    user_permissions: null,
    permissions_ids: [],
};

export const getters = {};

export const actions = {
    setSelectedUser({ commit }, data) {
        commit("setSelectedUser", data);
    },
    //eslint-disable-next-line
    setUsersForPermissions({ commit, state }) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/admin/roleusers", {
                    params: { role_name: "Certificate Team" },
                })
                .then((response) => {
                    commit("setUsersForPermissions", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setUserPermissions({ commit, state }, userId) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/admin/getuserpermissions", {
                    params: { user_id: userId },
                })
                .then((response) => {
                    commit("setUserPermissions", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    // eslint-disable-next-line
    saveUsersPermissions({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/admin/saveuserspermissions", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    updatedPermissionsIds({ commit }, data) {
        commit("updatedPermissionsIds", data);
    },
    removePermissionsIds({ commit }, data) {
        commit("removePermissionsIds", data);
    },
};

export const mutations = {
    setSelectedUser(state, payload) {
        state.selected_user = payload;
    },
    setUsersForPermissions(state, payload) {
        state.user_data = payload;
    },
    setUserPermissions(state, payload) {
        state.permissions_ids = null;
        state.permissions_ids = [];

        //loop through and set the active ones

        for (let i = 0; i < payload.length; i++) {
            for (let k = 0; k < payload[i].permissions.length; k++) {
                if (payload[i].permissions[k].selected == 1) {
                    state.permissions_ids.push(payload[i].permissions[k].id);
                }
            }
        }
        state.user_permissions = payload;
    },
    updatedPermissionsIds(state, payload) {
        const index = state.permissions_ids.indexOf(payload);

        if (index === -1) {
            // If 5 is not in the array, push it
            state.permissions_ids.push(payload);
        } else {
            // If 5 is already in the array, remove it
            state.permissions_ids.splice(index, 1);
        }
    },
    removePermissionsIds(state, payload) {
        const index = state.permissions_ids.indexOf(payload);

        if (index >= 0) {
            // If 5 is not in the array, push it
            state.permissions_ids.splice(index, 1);
        }
    },
};
